module.exports = __webpack_public_path__ + "img/home_53.d02fcca8.png";